module.exports = __webpack_public_path__ + "img/3-section-model-yr.e2b44db2.jpeg";